/**
 * PST-Import, version 1: one JSON file that describes a project - its master
 * data, contacts, schedule, cost planning, tendering and time categories.
 * Each module reads only its own section, so a file may carry all of them
 * or just one (ADR 0002); the additions after the first release are optional
 * sections, so older files stay valid.
 *
 * Written to be produced by a language model in a chat from a tender and an
 * offer, and to be read by a person. Dates are ISO 8601 (YYYY-MM-DD). Every
 * part except `project.number` and `project.name` is optional.
 *
 * The same structure is documented for authors in docs/IMPORT.md and as a
 * JSON Schema in packages/api/assets/pst-import-v1.schema.json.
 */
export const IMPORT_FORMAT = 'pst-import';
export const IMPORT_VERSION = 1;
export const TASK_STATUSES = ['open', 'running', 'done', 'blocked'];
/** The parts of a file, as offered on export and import. */
export const IMPORT_PARTS = [
    { key: 'projectdata', module: 'projectdata', label: 'Projektdaten und Kontakte' },
    { key: 'schedule', module: 'scheduling', label: 'Terminplan' },
    { key: 'costs', module: 'costs', label: 'Kostenplanung' },
    { key: 'tendering', module: 'tendering', label: 'Ausschreibung und Vergabe' },
    { key: 'time', module: 'projectdata', label: 'Zeiterfassung (Kategorien und Budgets)' },
];
//# sourceMappingURL=import-format.js.map